import { lazy } from "react";
import { Navigate } from "react-router-dom";
// components
import React from "react";
import Loadable from "../components/Loadable";
import Dashboard from "../EmployerPages/Dashboard";
import MyJobs from "../EmployerPages/MyJobs";
import MyProfile from "../EmployerPages/MyProfile";
import PostJob from "../EmployerPages/PostJob";
import SearchJobSeeker from "../EmployerPages/SearchJobSeeker";
import ViewProfile from "../EmployerPages/ViewProfile";
import JobSeekerProfile from "../JobSeekerPages/MyProfile";
import SearchCompany from "../JobSeekerPages/SearchCompanies";
import ViewCompany from "../JobSeekerPages/ViewCompany";
import GeneralLayout from "../layouts/GeneralLayout";
import Aboutus from "../pages/Aboutus";
import Contactus from "../pages/Contactus";
import EmployerSignup from "../pages/EmployerSignup";
import FAQs from "../pages/FAQs";
import JobSeekerSignup from "../pages/JobSeekerSignup";
import Login from "../pages/Login";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Search from "../pages/Search";
import Terms from "../pages/Terms";
// import
// routes
import Settings from "../EmployerPages/Settings";
import ViewJob from "../EmployerPages/viewJob";
import Connections from "../jobseekerComponents/connections/Connections";
import HomeFeed from "../JobSeekerPages/Dashboard/HomeFeed";
import JobApplications from "../JobSeekerPages/Dashboard/JobApplications";
import Messages from "../JobSeekerPages/Dashboard/Messages";
import { AllPosts } from "../JobSeekerPages/MyPosts";
import CompanyHome from "../JobSeekerPages/protectedRoute/CompanyHome";
import JobseekerHome from "../JobSeekerPages/protectedRoute/JobseekerHome";
import routeNames from "./routeNames";
import MyDashboardStats from "../JobSeekerPages/Dashboard/Stats";
import CompanyPosts from "../JobSeekerPages/CompanyPosts";
// pages
const Home = Loadable(lazy(() => import("../pages/Home")));
const Page404 = Loadable(lazy(() => import("../pages/Page404")));

export const general = {
  path: "/",
  element: <GeneralLayout />,
  // element: <AdminHome />,
  children: [
    //general
    { path: routeNames.general.landing, element: <Home /> },
    { path: routeNames.general.search, element: <Search /> },
    { path: routeNames.general.search2, element: <Search /> },
    { path: routeNames.general.search3, element: <Search /> },
    { path: routeNames.general.search4, element: <Search /> },
    { path: routeNames.general.employer, element: <EmployerSignup /> },
    { path: routeNames.general.jobSeeker, element: <JobSeekerSignup /> },
    { path: routeNames.general.login, element: <Login /> },
    { path: routeNames.general.aboutUs, element: <Aboutus /> },
    { path: routeNames.general.contactus, element: <Contactus /> },
    { path: routeNames.general.terms, element: <Terms /> },
    { path: routeNames.general.privacy, element: <PrivacyPolicy /> },
    { path: routeNames.general.faqs, element: <FAQs /> },
    { path: routeNames.general.viewJob, element: <ViewJob /> },
    { path: routeNames.general.notFound, element: <Page404 /> },

    //employer
    {
      path: "/employer/",
      element: <CompanyHome />,
      children: [
        { path: routeNames.employer.dashboard, element: <Dashboard /> },
        { path: routeNames.employer.postAJob, element: <PostJob /> },
        {
          path: routeNames.employer.searchJokSeeker,
          element: <SearchJobSeeker />,
        },
        { path: routeNames.employer.myJobs, element: <MyJobs /> },
        { path: routeNames.employer.myProfile, element: <MyProfile /> },
        { path: routeNames.employer.viewProfile, element: <ViewProfile /> },
        { path: routeNames.employer.settings, element: <Settings /> },
        { path: routeNames.employer.myposts, element: <Settings /> },
        // { path: "/emplyer/", element: <Navigate to={routeNames.general.landing} /> },
        { path: "*", element: <Navigate to={routeNames.general.landing} /> },
      ],
    },

    //jobSeeker
    {
      path: "/jobSeeker/",
      element: <JobseekerHome />,
      children: [
        {
          path: routeNames.jobSeeker.homeFeed,
          element: <HomeFeed />,
        },
        {
          path: routeNames.jobSeeker.connections,
          element: <Connections />,
        },

        { path: routeNames.jobSeeker.searchJob, element: <Search /> },
        {
          path: routeNames.jobSeeker.searchPeople,
          element: <SearchJobSeeker />,
        },
        { path: routeNames.jobSeeker.myProfile, element: <JobSeekerProfile /> },
        {
          path: routeNames.jobSeeker.searchCompany,
          element: <SearchCompany />,
        },
        { path: routeNames.jobSeeker.viewCompany, element: <ViewCompany /> },
        { path: routeNames.jobSeeker.viewProfile, element: <ViewProfile /> },
        { path: routeNames.jobSeeker.settings, element: <Settings /> },
        {
          path: routeNames.jobSeeker.jobapplications,
          element: <JobApplications />,
        },
        { path: routeNames.jobSeeker.messages, element: <Messages /> },
        { path: routeNames.jobSeeker.myposts, element: <AllPosts /> },
        {
          path: routeNames.jobSeeker.followedCompanyPosts,
          element: <CompanyPosts />,
        },
        { path: routeNames.jobSeeker.dashboard, element: <MyDashboardStats /> },
      ],
    },

    //adminF
    // { path: routeNames.admin.dashboard, element: <AdminDashboard /> },
  ],
};
